import { render, staticRenderFns } from "./index_management_good.vue?vue&type=template&id=28194b9c&"
import script from "./index_management_good.vue?vue&type=script&lang=js&"
export * from "./index_management_good.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports